import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Allow selectedChildModule to be either a number or null
const initialState:any = {
    selectedModule: 0,
    selectedChildModule: null,
    render:false,
    callEntityApi:false,
    sideNavCollapse:false,
};

const sidenavSlice = createSlice({
    name: 'SidenavSettings',
    initialState,
    reducers: {
        updateSelectedModule: (state, action: PayloadAction<number>) => {
            state.selectedModule = action.payload;
            state.selectedChildModule = null; // Set to null when module changes
        },
        updateSelectedChildModule: (state, action: PayloadAction<number>) => {
            state.selectedChildModule = action.payload;
        },
        resetSidenav: (state) => {
            state.selectedModule = initialState.selectedModule;
            state.selectedChildModule = initialState.selectedChildModule;
        },
        rendersidenav: (state,action: PayloadAction<boolean>) => {
            state.render = action.payload;
            
        },
        setSideNavCollapse(state, action) {
            state.sideNavCollapse = action.payload;
          },
        renderEntityApi: (state,action: PayloadAction<boolean>) => {
            state.callEntityApi = action.payload;
            
        },
    },
});

export const { setSideNavCollapse,updateSelectedModule, updateSelectedChildModule, resetSidenav ,rendersidenav,renderEntityApi} = sidenavSlice.actions;

export default sidenavSlice.reducer;
